<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="attachment-keyword-tab" :class="{ 'form-disabled': disabled }">
    <div class="row">
      <!-- Attachment Document (FORM02: attachment_document_keyword.cat_emcr_attachments) -->
      <div v-if="isTableVisible(ATTACHMENT_KEYWORD_TAB, ATTACHMENTS_FIELD)" class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3 pb-2 d-flex align-items-center justify-content-between" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">
              Attachment Document <span v-if="isTableMandatory(ATTACHMENT_KEYWORD_TAB, ATTACHMENTS_FIELD)" class="exclamation-mark-error-tab">*</span>
            </h6>
            <ButtonPrime v-if="canAddRow(ATTACHMENT_KEYWORD_TAB, ATTACHMENTS_FIELD)" icon="pi pi-plus" label="Add" size="small" :disabled="disabled" @click="addRow(ATTACHMENT_KEYWORD_TAB, ATTACHMENTS_FIELD)" />
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[ATTACHMENTS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="400px">
              <Column v-if="isColumnVisibleFn('folder_name', ATTACHMENTS_FIELD, ATTACHMENT_KEYWORD_TAB)" header-class="bg-light text-center">
                <template #header>
                  Folder Name <span v-if="isColumnMandatoryFn('folder_name', ATTACHMENTS_FIELD, ATTACHMENT_KEYWORD_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <SelectPrime show-clear v-model="data.folder_name" size="small" fluid
                    :options="dialog.options[columnOptionsKey(ATTACHMENT_KEYWORD_TAB, ATTACHMENTS_FIELD, 'folder_name', data)]"
                    option-label="label" option-value="value" placeholder="Folder Name"
                    :invalid="isColumnInvalidFn(data, 'folder_name')"
                    :disabled="disabled || !isColumnEnabledFn('folder_name', ATTACHMENTS_FIELD, ATTACHMENT_KEYWORD_TAB) || isAttachmentLocked(data)"
                    @show="loadColumnOptions(ATTACHMENT_KEYWORD_TAB, ATTACHMENTS_FIELD, 'folder_name', data)"
                  >
                    <template #value="{ value, placeholder }">
                      <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(ATTACHMENT_KEYWORD_TAB, ATTACHMENTS_FIELD, 'folder_name', data)], value) }}</span>
                      <span v-else>{{ placeholder }}</span>
                    </template>
                  </SelectPrime>
                </template>
              </Column>
              <Column v-if="isColumnVisibleFn('file_code', ATTACHMENTS_FIELD, ATTACHMENT_KEYWORD_TAB)" header-class="bg-light text-center">
                <template #header>
                  Attachment Link <span v-if="isColumnMandatoryFn('file_code', ATTACHMENTS_FIELD, ATTACHMENT_KEYWORD_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <!-- Diisi dari SmartCat Attachment (modal Browse), tidak diketik manual. -->
                <template #body="{ data, index }">
                  <div class="d-flex gap-1">
                    <InputText :model-value="data.file_attachment?.original_filename || data.file_code" size="small" placeholder="Browse file" disabled fluid
                      :invalid="isColumnInvalidFn(data, 'file_code')" />
                    <ButtonPrime v-tooltip.top="'Browse from SmartCat Attachment'" icon="pi pi-folder-open" size="small" outlined
                      :disabled="disabled || !isColumnEnabledFn('file_code', ATTACHMENTS_FIELD, ATTACHMENT_KEYWORD_TAB) || isAttachmentLocked(data)"
                      @click="openBrowse(index)" />
                  </div>
                </template>
              </Column>
              <Column header-class="bg-light text-center" body-class="text-center" style="width: 90px">
                <template #header>View</template>
                <template #body="{ data }">
                  <ButtonPrime v-if="data.file_code" label="View" size="small" outlined @click="previewAttachment(data)" />
                </template>
              </Column>
              <Column v-for="flag in visibleFlagColumns" :key="flag.column" header-class="bg-light text-center" body-class="text-center">
                <template #header>{{ flag.label }}</template>
                <template #body="{ data }">
                  <Checkbox v-model="data[flag.column]" :binary="true" true-value="X" :false-value="null"
                    :disabled="disabled || !isColumnEnabledFn(flag.column, ATTACHMENTS_FIELD, ATTACHMENT_KEYWORD_TAB) || (flag.lockable && isAttachmentLocked(data))" />
                </template>
              </Column>
              <!-- Baris yang sudah terkirim ke SAP (document_number / application_id / file_id terisi) atau terkunci (MCR003: baris
                   dari DB) tidak bisa dihapus. -->
              <Column v-if="canRemoveRow(ATTACHMENT_KEYWORD_TAB, ATTACHMENTS_FIELD)" header-class="bg-light" style="width: 56px">
                <template #body="{ data, index }">
                  <ButtonPrime icon="pi pi-trash" severity="danger" text size="small" :disabled="disabled || isSyncedToSap(data) || isAttachmentLocked(data)" @click="removeRow(ATTACHMENTS_FIELD, index)" />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>

      <!-- Keyword (FORM02: attachment_document_keyword.cat_emcr_keywords) -->
      <div v-if="isTableVisible(ATTACHMENT_KEYWORD_TAB, KEYWORDS_FIELD)" class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3 pb-2 d-flex align-items-center justify-content-between" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">
              Keyword <span v-if="isTableMandatory(ATTACHMENT_KEYWORD_TAB, KEYWORDS_FIELD)" class="exclamation-mark-error-tab">*</span>
            </h6>
            <ButtonPrime v-if="canAddRow(ATTACHMENT_KEYWORD_TAB, KEYWORDS_FIELD)" icon="pi pi-plus" label="Add" size="small" :disabled="disabled" @click="addRow(ATTACHMENT_KEYWORD_TAB, KEYWORDS_FIELD)" />
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[KEYWORDS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="400px">
              <Column header-class="bg-light text-center">
                <template #header>
                  Keyword <span v-if="isColumnMandatoryFn('keyword', KEYWORDS_FIELD, ATTACHMENT_KEYWORD_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <InputText v-model="data.keyword" size="small" placeholder="Keyword" fluid
                    :invalid="isColumnInvalidFn(data, 'keyword')"
                    :disabled="disabled || !isColumnEnabledFn('keyword', KEYWORDS_FIELD, ATTACHMENT_KEYWORD_TAB)"
                    @input="data.keyword = (data.keyword || '').toUpperCase()"
                  />
                </template>
              </Column>
              <Column v-if="canRemoveRow(ATTACHMENT_KEYWORD_TAB, KEYWORDS_FIELD)" header-class="bg-light" style="width: 56px">
                <template #body="{ index }">
                  <ButtonPrime icon="pi pi-trash" severity="danger" text size="small" :disabled="disabled" @click="removeRow(KEYWORDS_FIELD, index)" />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>

    <DialogPrime v-model:visible="browseModal.visible" header="Browse from SmartCat Attachment" :style="{ width: '55rem', margin: '10px' }" content-class="p-0" modal>
      <SmartcatAttachmentComp v-if="browseModal.visible" used-in="CataloguerForm" @file-selected="onFileSelected" />
    </DialogPrime>

    <DialogPrime v-model:visible="previewModal.visible" header="Preview Attachment" :style="{ width: '45rem' }" modal dismissable-mask @hide="closePreview">
      <div v-if="previewModal.loading" class="text-center py-4">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <div v-else>
        <div v-if="previewModal.fileType === 'image'" class="text-center">
          <img :src="previewModal.fileUrl" :alt="previewModal.fileName" class="img-fluid" />
        </div>
        <div v-else-if="previewModal.fileType === 'pdf'" class="text-center">
          <iframe :src="previewModal.fileUrl" style="width: 100%; height: 400px; border: none;"></iframe>
        </div>
        <div v-else class="text-center">
          <p class="text-muted">File cannot be previewed. <a :href="previewModal.fileUrl" target="_blank" rel="noopener">Download</a></p>
        </div>
      </div>
    </DialogPrime>
  </div>
</template>

<script>
import api from "@/helpers/api";
import formConfigHelper from "@/helpers/New_formConfig";
import smartcatAttachmentService from "@/services/dictionary/smartcatAttachmentService";
import { cataloguerTabMixin, useCataloguerTabEngine, createTabDialog } from "./New_CataloguerTab";

// Key tab & field repeatable di FORM02_BASE.json
const ATTACHMENT_KEYWORD_TAB = "attachment_document_keyword";
const ATTACHMENTS_FIELD = "cat_emcr_attachments";
const KEYWORDS_FIELD = "cat_emcr_keywords";

// Kolom centang X/null (layout). `lockable`: ikut dikunci untuk baris yang sudah sinkron SAP (aturan tab lama).
// Kolom status_sap/status_deletion/document_number/application_id/file_id ada di config (supaya tersimpan) tapi tidak dirender.
const FLAG_COLUMNS = [
  { column: "sap", label: "SAP", lockable: true },
  { column: "del_ind", label: "Del Ind", lockable: false }
];

const IMAGE_EXT = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];

// Props, setup engine, dialog, bind ke mcrItem, addRow/removeRow/opsi kolom: kerangka bersama New_CataloguerTab.js.
export default {
  name: "AttachmentKeywordTab",
  mixins: [cataloguerTabMixin],
  setup(props) {
    return useCataloguerTabEngine(props);
  },
  data() {
    return {
      ATTACHMENT_KEYWORD_TAB,
      ATTACHMENTS_FIELD,
      KEYWORDS_FIELD,
      FLAG_COLUMNS,
      dialog: createTabDialog(this.mcrItem),
      browseModal: { visible: false, rowIndex: null },
      previewModal: { visible: false, loading: false, fileUrl: "", fileType: "", fileName: "" }
    };
  },
  computed: {
    // Kolom centang tampil kalau minimal satu di antaranya visible untuk mcr_type/company ini.
    visibleFlagColumns() {
      return FLAG_COLUMNS.filter((flag) => this.isColumnVisibleFn(flag.column, ATTACHMENTS_FIELD, ATTACHMENT_KEYWORD_TAB));
    }
  },
  methods: {
    hasValue(value) {
      return formConfigHelper.isFilledValue(value);
    },
    // Sudah terkirim ke SAP: document_number, application_id, atau file_id terisi.
    isSyncedToSap(row) {
      return this.hasValue(row.document_number) || this.hasValue(row.application_id) || this.hasValue(row.file_id);
    },
    // Aturan tab lama: MCR002 -> baris yang sudah sinkron SAP (ketiganya terisi) dikunci; MCR003 -> baris dari DB (punya id)
    // dikunci. Kunci tampilan saja -- nilainya tetap ikut payload (bukan `enabled: false`, yang membuat Guard menghapusnya).
    isAttachmentLocked(row) {
      if (this.mcrType === "MCR002") {
        return this.hasValue(row.document_number) && this.hasValue(row.application_id) && this.hasValue(row.file_id);
      }
      if (this.mcrType === "MCR003") return !!row.id;
      return false;
    },
    openBrowse(index) {
      if (this.disabled) return;
      this.browseModal = { visible: true, rowIndex: index };
    },
    onFileSelected(fileData) {
      const row = this.mcrItem[ATTACHMENTS_FIELD]?.[this.browseModal.rowIndex];
      if (row) {
        row.file_code = fileData.file_code;
        row.file_attachment = fileData;
      }
      this.browseModal = { visible: false, rowIndex: null };
    },
    getFileType(fileName) {
      const ext = String(fileName).split(".").pop()?.toLowerCase() || "";
      if (IMAGE_EXT.includes(ext)) return "image";
      if (ext === "pdf") return "pdf";
      return "other";
    },
    async previewAttachment(row) {
      const fileCode = row?.file_code;
      if (!fileCode) return;
      if (fileCode.startsWith("http://") || fileCode.startsWith("https://")) {
        window.open(fileCode, "_blank");
        return;
      }
      this.previewModal = { visible: true, loading: true, fileUrl: "", fileType: "", fileName: fileCode };
      try {
        const fileBlob = await api(this, smartcatAttachmentService.fileByCode(fileCode), false);
        this.previewModal.fileUrl = URL.createObjectURL(fileBlob);
        this.previewModal.fileType = this.getFileType(row.file_attachment?.original_filename || fileCode);
      } catch (error) {
        this.$toast?.add({ severity: "error", summary: "Error", detail: "Failed to load file.", life: 2500 });
        this.previewModal.visible = false;
      } finally {
        this.previewModal.loading = false;
      }
    },
    closePreview() {
      if (this.previewModal.fileUrl?.startsWith("blob:")) URL.revokeObjectURL(this.previewModal.fileUrl);
      this.previewModal = { visible: false, loading: false, fileUrl: "", fileType: "", fileName: "" };
    },
    // Hook kerangka bersama, dipanggil tiap item dipilih/berganti.
    onItemBound() {
      this.ensureTableArrays(ATTACHMENT_KEYWORD_TAB);
      this.preloadTabLabels(ATTACHMENT_KEYWORD_TAB);
    }
  }
};
</script>
